import React from 'react';
import Box from '../Box/Box';
import { SxProp } from '../style/sxProp';
import ProviderLogo from '../ProviderLogo/ProviderLogo';
import Typography from '../Typography/Typography';

export type Props = {
  label: string;
  providerLogoSrc?: string;
  disabled?: boolean;
  sx?: SxProp;
  providerLogoSx?: SxProp;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const LayoutGridItem: React.FC<React.PropsWithChildren<Props>> = ({
  label,
  providerLogoSx,
  providerLogoSrc,
  sx,
  disabled,
  onClick,
}) => (
  <Box
    as="button"
    aria-label={label}
    onClick={onClick}
    disabled={disabled}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      padding: '.5',
      border: '0px solid',
      borderColor: {
        type: 'theme',
        colorLegacy: 'Primary/10',
        colorNext: 'brand/surface',
      },
      borderRadius: '8px',
      alignItems: 'center',
      backgroundColor: {
        type: 'theme',
        colorLegacy: 'Neutral/0',
        colorNext: 'background/default',
      },
      opacity: disabled ? 0.5 : 1, // Reduce opacity when disabled
      cursor: disabled ? 'not-allowed' : 'pointer', // Change cursor
      '&:hover': {
        backgroundColor: disabled
          ? {
              type: 'theme',
              colorLegacy: 'Neutral/0',
              colorNext: 'background/default',
            }
          : {
              type: 'theme',
              colorLegacy: 'Primary/10',
              colorNext: 'brand/surface',
            },
      },
      '&:active': {
        backgroundColor: disabled
          ? {
              type: 'theme',
              colorLegacy: 'Neutral/0',
              colorNext: 'background/default',
            }
          : {
              type: 'theme',
              colorLegacy: 'Primary/20',
              colorNext: 'brand/surface',
            },
      },
      '&:focus': {
        backgroundColor: {
          type: 'theme',
          colorLegacy: 'Primary/20',
          colorNext: 'brand/surface',
        },
      },
      // This kinda "breaks" the type system for sx, but it's because there's a disconnect between how we setup our SxProp and the native CSS types.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ...(sx || ({} as any)),
    }}
  >
    <ProviderLogo
      aria-hidden
      size="large"
      src={providerLogoSrc}
      imgSx={providerLogoSx}
    />
    <Typography aria-hidden variant="caption">
      {label}
    </Typography>
  </Box>
);

export default LayoutGridItem;
